/**
 *  CYCLE DE VIE d'un bon
 */

export enum Status {
    DRAFT, CREATED, PENDING, REFUSED, SIGNED, INVOICING, UNSIGNED, ARCHIVED
}